module.exports = __webpack_public_path__ + "static/media/Q7-9.7e178cf9.jpg";